import { XIcon } from 'lucide-react'
import Button from './Button'

const CloseButton: React.FC<
  JSX.IntrinsicElements['div'] & { disabled?: boolean }
> = ({
  children,
  disabled = false,
  className = '',
  ...props
}) => (
  <Button
    className={className}
    disabled={disabled}
    {...props}
  >
    <span>
      <XIcon />
    </span>
    {children}
  </Button>
)
export default CloseButton
